<template>
  <table class="table table-bordered">
    <tbody>

      <tr>
        <th scope="row">{{$t("Name")}}:</th>
        <td>{{ client.name }}</td>
      </tr>

      <tr>
        <th scope="row">{{$t("Client ID")}}:</th>
        <td>{{ client.clientId }}</td>
      </tr>

      <tr>
        <th scope="row">{{$t("Email")}}:</th>
        <td>{{ client.email }}</td>
      </tr>

      <tr>
        <th scope="row">{{$t("Phone")}}:</th>
        <td>{{ client.phone }}</td>
      </tr>

      <tr>
        <th scope="row">{{$t("Contract Id")}}:</th>
        <td>{{ client.contractId }}</td>
      </tr>

      <tr>
        <th scope="row">{{$t("Portfolio Id")}}:</th>
        <td>{{ client.portfolios[0] }}</td>
      </tr>

    </tbody>
  </table>
</template>


<script>
export default {
  props: ['client'],
}
</script>



// WEBPACK FOOTER //
// src/-client-app/components/tables/ClientTable.vue